import React from "react";
import { Link } from "react-router-dom";
import PageBanner from "../components/PageBanner";
import Sidebar from "../components/Sidebar";
import { NAV, PAGE_BANNERS } from "../data/content";

export default function Resources() {
  const resources = NAV.find((n) => n.label === "Resources");
  return (
    <div>
      <PageBanner src={PAGE_BANNERS.resources} alt="Resources" fallbackKey="resources" />
      <div className="flex flex-col lg:flex-row gap-8">
        <Sidebar />
        <article className="flex-1 nn-content">
          <h1>Resources</h1>
          <p>Please browse the list of resources below.</p>
          <ul className="grid sm:grid-cols-2 gap-2">
            {resources.children.map((c) => (
              <li key={c.path}>
                <Link className="nn-link" to={c.path}>
                  {c.label}
                </Link>
              </li>
            ))}
          </ul>
        </article>
      </div>
    </div>
  );
}
